import * as React from 'react';
import { IMaskInput } from 'react-imask';

interface PhoneNumberMaskProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

export const PhoneNumberMask = React.forwardRef<HTMLElement, PhoneNumberMaskProps>(function PhoneNumberMask(
  props,
  ref,
) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      inputRef={ref}
      mask="(#00) 000-0000"
      definitions={{
        '#': /[1-9]/,
      }}
      onAccept={(value: any) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});
